import React, { useEffect } from "react";
import { RootState } from "@/store/store";
import { useSelector } from "react-redux";
import { IAdminFireBase } from "@/store/models/admin.models";
import {
  useCreateAdminMutation,
  useGetAdminByEmailQuery,
} from "@/store/rtk-api/admin.api";

export function withAdmin<T extends { admin: IAdminFireBase }>(
  WrappedComponent: React.ComponentType<T>
): React.FC<Omit<T, "admin">> {
  const WithAdmin: React.FC<Omit<T, "admin">> = (props) => {
    const user = useSelector((state: RootState) => state.user.user);
    const encodedEmail = encodeURIComponent(user!.email as string);
    const { data, error, isLoading, isSuccess } =
      useGetAdminByEmailQuery(encodedEmail);

    const [createAdmin, { isLoading: isCreating }] = useCreateAdminMutation();

    useEffect(() => {
      if (error && "status" in error && error.status === 401) {
        createAdmin({
          emails: [user!.email as string],
        }).unwrap();
      }
    }, [error, createAdmin, user]);

    if (isLoading || isCreating) {
      return <div>Loading...</div>;
    }

    if (!isSuccess && !data) {
      return <div>Loading...</div>;
    }

    return <WrappedComponent {...(props as T)} admin={data!} />;
  };

  return WithAdmin;
}
